import request from '@/utils/request';
import router from '@/router';

/* eslint-disable */
const actions = {
  async addSet({ dispatch, commit }, set) {
    try {
      const { data } = await request.post("sets", set);

      if (data.error) {
        throw Error("Server-side validation failed");
      }

      router.push({ name: "products.edit", params: { uuid: data.set.uuid } });
    } catch (err) {
      throw err;
    }
  }
};

export default actions;
